import styled from 'styled-components';
import { FontSizes } from '../../../../common/typography/typography.styles';

export const DeliveryOptionCardRightContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  align-items: stretch; /* ensures its own content expands */
  justify-content: space-between;
  flex: 1;
  border-left: 1.5px solid rgba(0, 0, 0, 0.06);
  padding: 1.6rem 0 1.6rem 1.6rem;

  @media (max-width: 650px) {
    padding: 2rem 1.2rem;
    flex-direction: row;
    border-left: none;
    border-top: 1.5px solid rgba(0, 0, 0, 0.06);
    button {
      display: none;
    }
  }
`;

export const PriceSelectSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  width: 100%;
  justify-content: space-between;

  @media (max-width: 650px) {
    width: auto;
  }
`;

export const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${({ theme }) => theme.colors.baseColors.grey100};
  font-size: ${FontSizes.small};

  svg {
    width: 14px;
  }

  @media screen and (min-width: 650px) {
    margin-top: 8px;
  }
`;

export const PriceSection = styled.div`
  flex: 0 0 auto;
  font-family: ${({ theme }) => theme.fonts.body.fontFamily};
  font-size: ${FontSizes.mediumPlus};
  font-style: normal;
  font-weight: 700;
  line-height: 2.4rem;
  letter-spacing: 0.5px;
`;

export const DeliveryInfoTagsSection = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap; /* ← allow items to flow onto new lines */
  gap: 4px 0; // vert horiz

  & > * {
    flex: 0 0 auto;
  }

  @media (max-width: 650px) {
    flex-direction: row;
    align-items: center;
  }
`;
